// extracted by mini-css-extract-plugin
export default {"titlePage":"historyWeb_titlePage__1p40U"};